import React from 'react';
import { FastForward, Delete } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface StickyActionBarProps {
  onQuickPick: () => void;
  onClear: () => void;
  className?: string;
}

/**
 * StickyActionBar - Sticky bar with Clear and Quick Pick buttons
 * Starts below CompetitionInfo, becomes sticky when scrolling
 */
const StickyActionBar: React.FC<StickyActionBarProps> = ({
  onQuickPick,
  onClear,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`sticky top-[64px] z-30 bg-app-background border-b border-border/30 p-4 ${className}`}
      data-test-id="sticky-action-bar"
    >
      <div className="flex gap-3">
        {/* Clear Button - Grey/Secondary with backspace icon */}
        <Button
          variant="secondary"
          onClick={onClear}
          className="flex-1"
          data-test-id="clear-button"
        >
          <Delete className="w-4 h-4 mr-2" />
          {t('actions.clear')}
        </Button>

        {/* Quick Pick Button - Green/Bet99 with fast-forward icon */}
        <Button
          variant="bet99"
          onClick={onQuickPick}
          className="flex-1"
          data-test-id="quick-pick-button"
        >
          <FastForward className="w-4 h-4 mr-2" />
          {t('actions.quickPick')}
        </Button>
      </div>
    </div>
  );
};

export default StickyActionBar;
